//imports
import {
    BRAND_DELETE_OPEN_MODAL,
    BRAND_DELETE_REQUEST,
    BRAND_DELETE_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    brand: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case BRAND_DELETE_OPEN_MODAL:
            return { ...state, openModal: true, brand: action.payload.brand }

        case BRAND_DELETE_REQUEST:
            return { ...state, loading: true }

        case BRAND_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "BRAND_DELETE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};